module.exports = __webpack_public_path__ + "images/emoji/sunrise_over_mountains.51ffa72c87ed93ff442e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sunrise_over_mountains.png
// module id = qVcS
// module chunks = 13